import { render, staticRenderFns } from "./public-header2.vue?vue&type=template&id=86de21bc&scoped=true&"
import script from "./public-header2.vue?vue&type=script&lang=js&"
export * from "./public-header2.vue?vue&type=script&lang=js&"
import style0 from "./public-header2.vue?vue&type=style&index=0&id=86de21bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86de21bc",
  null
  
)

export default component.exports